import { getJson, postJson, putJson, deleteJson, withDone, withValidate } from '@rad/utility/http';
export const getForms = () => getJson('/api/forms');
export const getForm = (id) => getJson(`/api/forms/${id}`);
export const createForm = (f) => withDone(withValidate(postJson('/api/forms', f)))();
export const updateForm = (f) => withDone(withValidate(putJson('/api/forms', f)))();
export const deleteForm = (id) => withDone(deleteJson(`/api/forms/${id}`))();
